import * as React from "react";

// interfaces
import * as Modal from "react-modal";
import { IModal, TableColum } from "./interfaces";

// components
import EditorModalTable from "./EditorModalTable";

// libs
// helpers
import { getRandomKey } from "../../helpers/Utils";

interface ModalEditorProps extends IModal {
	// TODO: abstract type
	cells: object;
	hiddenColumns?: Array<TableColum>
	data: any;
}

interface ModalEditorState {
	open: boolean;
	mode: string;
}

class ModalEditor extends React.Component<ModalEditorProps, ModalEditorState> {
	state = {
		open: false,
		mode: "rows",
	};

	// eslint-disable-next-line react/no-unused-class-component-methods
	onShow = (mode: string): void => {
		this.setState({ open: true, mode });
	};

	render() {
		const closeModal = () => this.setState({ open: false });
		let modal_value = this.props.cells;
		let modal_columns = this.props.columns;
		if (this.state.mode === "title") {
			modal_columns = modal_columns.filter((col) => (col.extra && col.extra.allow_rename) || col.isKey);
			for (const col of modal_columns) {
				col.type = "text";
			}
			modal_value = {};
			// eslint-disable-next-line camelcase
			// @ts-ignore
			modal_value.spec_col_names = true;
			if (this.props.titleRow) {
				for (const col of modal_columns) {
					modal_value[col.field] = this.props.titleRow[col.field];
				}
			} else {
				for (const col of modal_columns) {
					if (col.isKey) {
						modal_value[col.field] = `key_${getRandomKey()}`;
					} else {
						modal_value[col.field] = col.name;
					}
				}
			}
		}

		return (
			// @ts-ignore
			<Modal
				isOpen={this.state.open}
				className="react-bs-insert-modal modal-dialog"
				contentLabel="Modal"
				ariaHideApp={false}
			>
				<EditorModalTable
					title={"Редактировать"}
					value={modal_value}
					onModalClose={closeModal}
					columns={modal_columns}
					onSave={this.props.onSave}
					titleRow={this.props.titleRow}
					api={this.props.api}
					mode={this.state.mode}
					rowCount={this.props.rowCount}
					opts={this.props.opts}
					dispatcher={this.props.dispatcher}
					disabled={this.props.disabled}
					schema={this.props.schema}
				/>
			</Modal>
		);
	}
}

export default ModalEditor;
